import { LevelPlayIframe as Activity } from '.'

export const SLUG = 'iframe'
export const activity = {
  SLUG,
  interactionMode: {
    kind: 'continue',
    waitValidation: false
  },
  Component: Activity
}
